import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/contexts/AuthContext';
import { recuentosAPI } from '@/lib/recuentos';
import { EstadoSemanalCard } from '@/pages/recuentos/EstadoSemanalCard';
import { NuevoRecuentoDialog } from '@/pages/recuentos/NuevoRecuentoDialog';
import { HistorialTab } from './recuentos/HistorialTab';
import { CatalogoTab } from './recuentos/CatalogoTab';
import { ConfigTab } from './recuentos/ConfigTab';
import { RecuentoDetalleDialog } from './recuentos/RecuentoDetalleDialog';

export default function AdminRecuentosPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [lugares, setLugares] = useState([]);
  const [nuevoOpen, setNuevoOpen] = useState(false);
  const [detalleId, setDetalleId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadLugares = () => recuentosAPI.lugares().then((r) => setLugares(r.data));
  useEffect(() => { loadLugares(); }, []);
  const refresh = () => setRefreshKey((k) => k + 1);

  return (
    <div className="space-y-6" data-testid="admin-recuentos-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <ClipboardCheck className="w-7 h-7 text-orange-500" /> Recuentos para Justo
          </h1>
          <p className="text-slate-500 mt-1 text-sm">Conteo físico semanal de cada lugar de stock y exportación a Justo</p>
        </div>
        <Button onClick={() => setNuevoOpen(true)} className="bg-orange-500 hover:bg-orange-600" data-testid="admin-nuevo-recuento-btn">
          <Plus className="w-4 h-4 mr-1" /> Nuevo recuento
        </Button>
      </div>

      <EstadoSemanalCard onOpen={setDetalleId} refreshKey={refreshKey} />

      <Tabs defaultValue="historial">
        <TabsList>
          <TabsTrigger value="historial" data-testid="tab-historial">Historial</TabsTrigger>
          <TabsTrigger value="catalogo" data-testid="tab-catalogo">Catálogo de ingredientes</TabsTrigger>
          <TabsTrigger value="config" data-testid="tab-config">Lugares y plantilla</TabsTrigger>
        </TabsList>
        <TabsContent value="historial">
          <HistorialTab lugares={lugares} onOpen={setDetalleId} refreshKey={refreshKey} />
        </TabsContent>
        <TabsContent value="catalogo"><CatalogoTab /></TabsContent>
        <TabsContent value="config"><ConfigTab lugares={lugares} onLugaresChange={loadLugares} /></TabsContent>
      </Tabs>

      <NuevoRecuentoDialog open={nuevoOpen} onOpenChange={setNuevoOpen} lugares={lugares.filter((l) => l.activo)} basePath="/admin/recuentos" defaultResponsable={user?.name} />
      <RecuentoDetalleDialog
        recuentoId={detalleId}
        onClose={() => setDetalleId(null)}
        onChanged={refresh}
        onEdit={(id) => navigate(`/admin/recuentos/${id}`)}
      />
    </div>
  );
}
